import React from 'react';

import { Entry } from 'contentful';

import { useIsTabletScreenWidthOrWider } from '../../helpers/hooks/useScreenWidth';
import { TypeProPBragBarSkeleton } from '../../interfaces/contentful';
import { ContinuousCarouselDots } from '../Carousels/ContinuousCarouselDots/ContinuousCarouselDots';
import { Container } from '../Container/Container';
import { Heading } from '../Heading/Heading';

import { CMSBragCard } from './BragBarCarouselCard';

interface IProps {
  bragBar: Entry<TypeProPBragBarSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>;
}

export const BragBarCarousel = ({ bragBar }: IProps) => {
  const isTabletScreenWidthOrWider = useIsTabletScreenWidthOrWider();
  const { title, valueItems } = bragBar.fields;

  return (
    <div className="py-sm" data-testid="BragBarSection">
      <Container className="flex flex-col items-center">
        <Heading variant="md" className="mb-1 text-left sm:text-center">
          {title}
        </Heading>

        {isTabletScreenWidthOrWider && (
          <div className="mx-auto mt-6 flex justify-between md:mt-8" data-testid="bragBar">
            {valueItems.map(value => {
              if (!value) {
                return <></>;
              }
              const { valueItemTitle, valueItemBody, valueItemImage } = value.fields;
              const imgSrc = valueItemImage?.fields.file?.url ?? '';
              const imgWidth = valueItemImage?.fields.file?.details.image?.width ?? 0;
              const imgHeight = valueItemImage?.fields.file?.details.image?.height ?? 0;

              return (
                <CMSBragCard
                  key={valueItemTitle}
                  imgSrc={imgSrc}
                  imgWidth={imgWidth}
                  imgHeight={imgHeight}
                  title={valueItemTitle}
                  body={valueItemBody}
                  className="w-col-4"
                />
              );
            })}
          </div>
        )}
      </Container>

      {!isTabletScreenWidthOrWider && (
        <ContinuousCarouselDots id="CMS Pro page" smallIndicatorSpacing>
          {valueItems.map(value => {
            if (!value) {
              return <></>;
            }
            const { valueItemTitle, valueItemBody, valueItemImage } = value.fields;
            const imgSrc = valueItemImage?.fields.file?.url ?? '';
            const imgWidth = valueItemImage?.fields.file?.details.image?.width ?? 0;
            const imgHeight = valueItemImage?.fields.file?.details.image?.height ?? 0;
            return (
              <CMSBragCard
                key={valueItemTitle}
                imgSrc={imgSrc}
                imgWidth={imgWidth}
                imgHeight={imgHeight}
                title={valueItemTitle}
                body={valueItemBody}
                className="w-full min-w-full snap-center"
              />
            );
          })}
        </ContinuousCarouselDots>
      )}
    </div>
  );
};
